// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"2785":"afb464cf561c92eb7f98","7308":"888d5be3037713d7919c"}[chunkId] + ".css";
};